import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { WidgetBaseComponent } from '../widget-base/widget-base.component';

@Component({
  selector: 'widget-embed-code',
  templateUrl: './embed-code.component.html',
  styleUrls: ['./embed-code.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EmbedCodeComponent
  extends WidgetBaseComponent
  implements OnInit, AfterViewInit
{
  /** Calculado uma única vez: um getter recriaria o SafeHtml (nova referência)
   * em cada change detection, forçando o Angular a repor o innerHTML e
   * destruir/recriar iframes a cada scroll. */
  markup: SafeHtml = '';

  constructor(private _elementRef: ElementRef<HTMLElement>) {
    super();
  }

  ngOnInit(): void {
    const css = this.widget?.css ? `<style>${this.widget.css}</style>` : '';
    const html = this.widget?.html || '';
    this.markup = this.sanitizeHtml(`${css}${html}`);
  }

  /** <script> injectado via innerHTML não corre; tem de ser criado e anexado ao DOM. */
  ngAfterViewInit(): void {
    if (!this.widget?.js) return;

    const scriptEl = document.createElement('script');
    scriptEl.type = 'text/javascript';
    scriptEl.text = this.widget.js;
    this._elementRef.nativeElement.appendChild(scriptEl);
  }
}
